export const TIER_BADGE_PROGRESS_ARIA_LABEL = 'Tier progress';
